 import DivLoader from 'components/divloader/DivLoader';
 import React, { useState, useEffect, useRef } from 'react';
 import { useParams } from 'react-router-dom';
 import { customerGenericLink } from "api/clients";
 import toast from 'react-hot-toast';
 
 function CustomerRegister() {
 
     const { client_id } = useParams()
     const [initialLoading,setInitialLoading] = useState(true);
     
     const generateLink = () => {
         setInitialLoading(true);
         customerGenericLink(client_id)
         .then((response) => {
            // console.log("Response",response)
           window.location.replace(response?.registration_link);
         }).catch((err) => {
           toast.error(
             err?.response?.data?.message ??
               "Something went wrong while cancelling subscription"
           );
           
         });
     }
 
     useEffect(() => {
         generateLink()
     },[])
 
     return (
         <>
             {initialLoading ? (
                 <div className="mt-5 pt-5">
                     <DivLoader className="m-5 h-6 w-6 border-indigo-500" />
                     <p className="text-center">Generating registration link, once link generated you will redirected to registration page....</p>
                 </div>
             ) : (
                 <></>
             )}
         </>
     )
 }
 
 export default CustomerRegister
 